<template>
  <div>
    <el-upload
      :action="baseUrl"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :on-success="uploadSuccess"
      :before-upload="beforeUpload"
      list-type="picture-card"
      :file-list="ImageUrls"
      style="display: flex; position: relative"
      :limit="limit"
      class="upload"
    >
      <i class="el-icon-plus" />
      <!-- <div style="position: absolute; bottom: 10px">图片/视频</div> -->
    </el-upload>
    <!-- 视频 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      append-to-body
      :close-on-click-modal="false"
    >
      <video
        controls
        name="media"
        style="
          width: 434px;
          height: 276px;
          background-color: #1e1e1e;
          margin: 15px 0;
        "
        :src="ImageUrl.split('?vframe')[0]"
      ></video>
    </el-dialog>
    <!-- 图片 -->
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      :close-on-click-modal="false"
    >
      <!-- <img width="100%" :src="ImageUrl" alt="" class="myimage"/> -->
      <el-image
        style="width: 400px; height: 400px"
        :src="ImageUrl"
        fit="fill"
      />
    </el-dialog>
  </div>
</template>
<script>
import environment from "@/utils/environment";
export default {
  props: {
    width: {
      type: Number,
      default: 50,
    },
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    limit: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      // baseUrl: `${process.env.VUE_APP_BASE_URL}/service-admin/admin/file/upload`,
      baseUrl: "",
      ImageUrls: [],
      dialogVisible: false,
      dialogVisible2: false, //视频
      ImageUrl: "",
    };
  },
  mounted() {
    this.baseUrl = environment.upLoadPath();
    this.getimages();
  },
  methods: {
    // 移除照片
    handleRemove(file, fileList) {
      var index = this.ImageUrls.findIndex((item) => item.url == file.url);
      if (index != -1) {
        this.ImageUrls.splice(index, 1);
      }
      this.Mychage(this.ImageUrls);
    },
    // 预览照片
    handlePictureCardPreview(file) {
      this.ImageUrl = file.url;
      if (this.ImageUrl.includes("mp4") || this.ImageUrl.includes("MOV")) {
        this.dialogVisible2 = true;
      } else {
        this.dialogVisible = true;
      }
    },
    // 上传成功函数
    uploadSuccess(response, file, fileList) {
      console.log("response", response);
      if (response.data.includes("mp4") || response.data.includes("MOV")) {
        var item = {
          name: "draw.jpg",
          url: response.data + "?vframe/jpg/offset/0",
        };
      } else {
        var item = {
          name: "draw.jpg",
          url: response.data,
        };
      }
      // var item = {
      //   name: "draw.jpg",
      //   url: response.data,
      // };
      this.ImageUrls.push(item);
      this.Mychage(this.ImageUrls);
    },
    // 加载图片
    getimages() {
      // console.log("this.images",this.images)
      this.ImageUrls = [];
      this.images.forEach((item) => {
        // if (this.ImageUrl.includes('mp4') || this.ImageUrl.includes('MOV')){
        //   var params = {
        //     name: "draw.jpg",
        //     url: item + '?vframe/jpg/offset/0',
        //   };
        // }
        // else {
        //   var params = {
        //     name: "draw.jpg",
        //     url: item,
        //   };
        // }
        var params = {
          name: "draw.jpg",
          url: item,
        };

        this.ImageUrls.push(params);
      });
    },
    init(url) {
      console.log(url);
      this.ImageUrls = url;
    },
    // 更改图片回调
    Mychage(items) {
      var _images = [];
      items.forEach((item) => {
        _images.push(item.url);
      });
      this.$emit("changeImages", _images);
    },
    // 上传前
    beforeUpload(file, fileList) {
      const size = Math.floor(file.size / 1024);
      if (size > 50 * 1024 * 1024) {
        // alert("请选择5M以内的图片");
        this.$message.error("请选择50M以内的文件");
        return false;
      }
      //   if (file.type !== "image/png" && file.type !== "image/jpeg") {
      //     this.$message.error("请选择png或者jpg格式的文件");
      //     return false;
      //   }
    },
  },
};
</script>
<style lang="scss" scoped>
.upload::v-deep {
  .el-upload--picture-card {
    width: 120px !important;
    height: 120px !important;
    // text-align: 1;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-upload-list {
    display: flex;
    flex-wrap: wrap;
    .el-upload-list__item {
      width: 120px !important;
      height: 120px !important;
    }

    .el-upload-list__item-thumbnail {
      width: 120px !important;
      height: 120px !important;
    }

    .el-upload-list__item-actions {
      font-size: 14px;
    }
  }
}
</style>
